import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'
import { i18n } from '@/i18n'

export default [
  {
    name: 'projects',
    path: '/projects',
    component: () => LazyLoadView(import(/* webpackChunkName: "projects" */ '@/views/Project/Projects.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-create',
    path: '/projects/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "project-create" */ '@/views/Project/Create.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-dashboard',
    path: '/projects/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "project-dashboard" */ '@/views/Project/Dashboard.vue')),
    meta: {
      bodyAttrs: { theme: 'Project.item.theme' },
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-edit',
    path: '/projects/:id/edit/:step?',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "project-mutate" */ '@/views/Project/Mutate/Component.vue')),
    meta: {
      bodyAttrs: { theme: 'Project.item.theme' },
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-fallback',
    path: '/projects/:id/fallback',
    props: true,
    meta: {
      navigation: false,
      footer: false,
      skipAuth: true,
      breadcrumb: { resource: 'Project', param: 'id' },
    },
    component: () => LazyLoadView(import(/* webpackChunkName: "project-fallback" */ '@/views/Project/Fallback.vue')),
  },
  {
    name: 'project-flatfinder-create',
    path: '/projects/:project/flatfinder/create/:step?',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "flatfinder-mutate" */ '@/views/Flatfinder/Mutate/Component.vue')),

    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-flatfinder-edit',
    path: '/projects/:project/flatfinder/:id/:step?',
    props: true,

    component: () =>
      LazyLoadView(import(/* webpackChunkName: "flatfinder-mutate" */ '@/views/Flatfinder/Mutate/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-leads',
    path: '/projects/:id/leads',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "project-leads" */ '@/views/Project/Leads/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-lead-create',
    path: '/projects/:reference/lead/create',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-create" */ '@/views/Lead/Create.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-lead-edit',
    path: '/projects/:reference/lead/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-mutate" */ '@/views/Lead/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-openhouse',
    path: '/projects/:id/openhouses',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "project-openhouse" */ '@/views/Project/Openhouse/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-openhouse-create',
    path: '/projects/:project/openhouse/create',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "openhouse-mutate" */ '@/views/Openhouse/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-openhouse-edit',
    path: '/projects/:project/openhouse/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "openhouse-mutate" */ '@/views/Openhouse/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-contracts',
    props: true,
    path: '/projects/:id/contracts',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "contracts" */ '@/views/Contract/Contracts/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-posts',
    path: '/projects/:id/posts',

    redirect: to => {
      return {
        name: 'project-edit',
        params: { id: to.params.id, step: `posts-${to.query.collection}` },
        query: { ...to.query, collection: undefined },
      }
    },
  },
  {
    name: 'project-complaints',
    path: '/projects/:id/complaints',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "tasks" */ '@/views/Task/Tasks.vue')),
    meta: {
      context: 'project',
      type: 'complaint',
      title: i18n.tc('complaint', 2),
      defaultFilter: ctx => ({
        search: '',
        type: 'complaint',
        status: ['request', 'undone'],
        reference: `Project:${ctx.$route.params.id}`,
      }),
      breadcrumb: ctx => ({ onModel: 'Project', ref: ctx.$route.params.id }),
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-analytics',
    path: '/projects/:id/analytics',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "project-analytics" */ '@/views/Project/Analytics.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-residentials',
    props: true,
    path: '/projects/:id/residentials',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "residentials" */ '@/views/Project/Residentials/Component.vue')),

    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-form-create',
    path: '/projects/:reference/form/create',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "project-form-create" */ '@/views/Form/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'project-form-edit',
    path: '/projects/:reference/form/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "project-form-mutate" */ '@/views/Form/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
]
